import MainLayout from "layouts/Main";
import { settingsTabs } from "views/Dashboard/Settings/tabs";

import FeesTable from "./FeesTable";

const Fees = () => {
  return (
    <MainLayout tabs={settingsTabs}>
      <FeesTable />
    </MainLayout>
  );
};

export default Fees;
